"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const SessionDefinition_1 = require("../SessionDefinition");
const Attendee_1 = require("./Attendee");
const TypeScriptUtils_1 = require("../../Common/TypeScriptUtils");
class SessionDto {
    constructor(sessionDto) {
        this.id = "";
        this.type = SessionDefinition_1.SessionType.Unknown;
        this.creator = Attendee_1.Creator.Nobody;
        this.attendees = new Set();
        this.attendedAttendees = new Map();
        this.needRecord = false;
        this.createdFrom = 0;
        this.endedTime = 0;
        this.status = SessionDefinition_1.Status.Unknown;
        if (sessionDto) {
            this.id = sessionDto.id || this.id;
            this.type = sessionDto.type || this.type;
            this.creator = new Attendee_1.Creator(sessionDto.creator) ? new Attendee_1.Creator(sessionDto.creator) : this.creator;
            if (sessionDto.attendees) {
                if (sessionDto.attendees instanceof Array) {
                    this.attendees = TypeScriptUtils_1.iterableObjToTypedSet(sessionDto.attendees, Attendee_1.Attendee);
                }
                else {
                    this.attendees = new Set(sessionDto.attendees);
                }
            }
            if (sessionDto.attendedAttendees) {
                if (sessionDto.attendedAttendees instanceof Map) {
                    this.attendedAttendees = new Map(sessionDto.attendedAttendees);
                }
                else {
                    this.attendedAttendees = TypeScriptUtils_1.objectToTypedKTypedVMap(sessionDto.attendedAttendees, { kctor: Attendee_1.Attendee });
                }
            }
            this.needRecord = sessionDto.needRecord || this.needRecord;
            this.createdFrom = sessionDto.createdFrom || Date.now();
            this.endedTime = sessionDto.endedTime || this.endedTime;
            this.status = sessionDto.status || this.status;
        }
    }
    toString() {
        return JSON.stringify(this);
    }
    toJSON() {
        const temp = new TempSessionDto(this);
        return temp;
    }
}
SessionDto.INVALID_SESSION = new SessionDto();
exports.SessionDto = SessionDto;
class TempSessionDto {
    constructor(sessionDto) {
        this.id = sessionDto.id;
        this.type = sessionDto.type;
        this.creator = sessionDto.creator;
        this.attendees = immutable_1.Set(sessionDto.attendees);
        this.attendedAttendees = immutable_1.Map(sessionDto.attendedAttendees);
        this.needRecord = sessionDto.needRecord;
        this.createdFrom = sessionDto.createdFrom;
        this.endedTime = sessionDto.endedTime;
        this.status = sessionDto.status;
    }
}
exports.TempSessionDto = TempSessionDto;
//# sourceMappingURL=SessionDto.js.map